import React from 'react'
import { Plus } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { FIGMA_KANBAN_COLUMN } from './figmaKanbanTheme'

interface FigmaKanbanAddStepButtonProps {
  onClick: () => void
}

/** Circular + control shown after the last kanban column (Figma). */
export function FigmaKanbanAddStepButton({ onClick }: FigmaKanbanAddStepButtonProps) {
  const { t } = useTranslation()

  return (
    <div
      className="flex shrink-0 items-center justify-center"
      style={{ height: FIGMA_KANBAN_COLUMN.height }}
    >
      <button
        type="button"
        onClick={onClick}
        className="flex h-16 w-16 items-center justify-center rounded-full text-white transition-opacity hover:opacity-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#19A6A6]/40"
        style={{ backgroundColor: '#34C75966' }}
        aria-label={t('kanban.addHiringStep', 'Add hiring step')}
        title={t('kanban.addHiringStep', 'Add hiring step')}
      >
        <Plus className="h-7 w-7" strokeWidth={2.5} />
      </button>
    </div>
  )
}
